exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".toaster{position:fixed;top:0;left:0;right:0;z-index:130;display:-ms-flexbox;display:flex;-ms-flex-direction:column;flex-direction:column;-ms-flex-align:center;align-items:center;pointer-events:none}", "", {"version":3,"sources":["/divvit-app/client/containers/Toaster/client/containers/Toaster/style.styl","/divvit-app/client/containers/Toaster/style.styl"],"names":[],"mappings":"AAAA,SACE,eAAA,MACA,OACA,QACA,YACA,oBACA,aAAA,0BACA,sBAAA,sBACA,mBAAA,mBACA,CCCD","file":"style.styl","sourcesContent":[".toaster\n  position: fixed\n  top: 0\n  left: 0\n  right: 0\n  z-index: toaster-z-index\n  display: flex\n  flex-direction: column\n  align-items: center\n  pointer-events: none\n",".toaster {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  z-index: 130;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  pointer-events: none;\n}\n/*# sourceMappingURL=client/containers/Toaster/style.css.map */"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader??ref--3-1!./node_modules/postcss-loader/lib??postcss!./node_modules/stylus-loader??ref--3-3!./client/containers/Toaster/style.styl
// module id = 404
// module chunks = 0